export const SPACE_PER_MONTH = 3.75; // in rem
